angular.module( 'acme.view.application.membership.benefits.modals.add', [
  'ui.router',
  'ui.bootstrap',
  'ui.sortable',
  'acme.view.application.membership.benefits.modals.add.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipBenefitsModalsAdd = {
        name: 'application.membership.benefits.modals.add',
        url: '/membership/benefits/modals/add',
        views: {
          "main": {
            controller: 'MembershipBenefitsModalsAddController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/membership/benefits/modals/add/add.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(membershipBenefitsModalsAdd);
});
